import { isDevelopmentEnv, isStagingEnv } from '@mc/client-env'
import { logger } from '@mc/next-logger'
import { isQuotaExceededError } from '../utils'

export const safeSetSessionStorageItem = (key: string, value: string): void => {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined')
    return

  try {
    sessionStorage.setItem(key, value)
  } catch (err) {
    if (isDevelopmentEnv() || isStagingEnv()) {
      if (isQuotaExceededError(err)) {
        logger.error(
          `Quota Exceeded (sessionStorage full) writing to key ["${key}"]`,
          err,
        )
      } else {
        logger.error(`Error setting sessionStorage key "${key}":`, err)
      }
    }
  }
}
